<div class="public-terms">
  <hip-modal>
    <hip-terms-and-conditions></hip-terms-and-conditions>
  </hip-modal>
</div>
